import {
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  title: string;
  description: string;
  label: string;
  confirmLabel: string;
  isLoading?: boolean;
  onConfirm: (justification: string) => void;
  onClose: () => void;
}

export const JustificationModal = ({
  isOpen,
  title,
  description,
  label,
  confirmLabel,
  isLoading,
  onConfirm,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  const [justification, setJustification] = useState("");

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="lg">{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontSize="sm" color="smText" mb="4">
            {description}
          </Text>
          <FormControl>
            <FormLabel htmlFor="dialogue-justification">{label}</FormLabel>
            <Textarea
              id="dialogue-justification"
              backgroundColor="smBackground"
              value={justification}
              onChange={(e) => setJustification(e.target.value)}
            />
            <FormHelperText>{t("The justification is written in the procurement protocol")}</FormHelperText>
          </FormControl>
        </ModalBody>
        <ModalFooter gap="2">
          <Button variant="ghost" onClick={onClose}>
            {t("Cancel")}
          </Button>
          <Button
            colorScheme="teal"
            isDisabled={justification.trim() === ""}
            isLoading={isLoading}
            onClick={() => onConfirm(justification.trim())}
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
